module.exports = __webpack_public_path__ + "static/media/features2_8.874c8561.png";